import React, { Component } from 'react';
import { DataHandler, APIHandler } from 'C4';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';

export default class ContactView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contacts: [],
    };
  }

  componentDidMount() {
    this.loadContacts();
  }

  async loadContacts() {
    const appId = await DataHandler.matchAppIdSync();
    APIHandler.getContacts(appId).then((res) => {
      this.setState({ contacts: res.response });
    });
  }

  render() {
    const { contacts } = this.state;
    return (
      <div className="contentContainer contact">
        <div className="contactHeader">
          {i18n.translate('nav.contact')}
          <div className="divider" />
        </div>
        <div className="contactView">
          {contacts.map((contact) => (
            <React.Fragment>
              {contact.name && (
                <div className="contactView__Card">
                  <div className="contactView__Content__Card">
                    <p>{contact.name}</p>
                    <a href={`mailto:${contact.emails[0].email}`}>{contact.emails[0].email}</a>
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }
}
